import React from 'react'

type IProps =
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
  & React.PropsWithChildren

export const Button = (props: IProps) => {
  return (
    <button className="button" {...props}>
      {props.children}
    </button>
  )
}